/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Badge } from '@wit/vtv-x-foundation-lib';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { ActionButton, AssetActionButton } from 'types/components/ActionButtonsGroup';
import { ActionButtonsGroup, BadgesGroup } from '..';

interface Props {
  className?: string;
  onClick?: () => void;
  backLabel?: string;
  backUrl?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  placeholder?: string;
  badges?: Badge[];
  actionButtons?: (ActionButton | AssetActionButton)[];
}

export default function SectionHero({
  className = '',
  onClick,
  backLabel,
  backUrl,
  title,
  subtitle,
  description,
  placeholder,
  badges,
  actionButtons,
}: Props): JSX.Element {
  const history = useHistory();
  const hasBadge = badges && badges.length;

  return (
    <div
      className={`hero-wrapper component-inner ${onClick ? 'cursor-pointer' : ''} ${className}`}
      onClick={onClick}
      id="SectionHero_wrapper"
    >
      <div className="hero-text hero-left">
        <div className="inner">
          {backLabel ? (
            <Link
              id="SectionHero_button___back"
              className="hero-link-back"
              to={backUrl || '#'}
              onClick={!backUrl ? history.goBack : undefined}
            >
              {backLabel}
            </Link>
          ) : null}
          {subtitle ? <h3 id="SectionHero_subtitle">{subtitle}</h3> : null}
          <h1 id="SectionHero_title">{title}</h1>
          {description ? (
            <p id="SectionHero_description" className="no-margin-bottom">
              {description}
            </p>
          ) : null}

          <p className={`hero-placeholder ${placeholder || (!placeholder && !hasBadge) ? 'no-margin-bottom' : ''}`}>
            {placeholder}
          </p>

          {hasBadge ? (
            <BadgesGroup className="light bold centered" badges={badges} bemBlock="SectionHeroBadges" />
          ) : null}

          {actionButtons ? (
            <ActionButtonsGroup
              bemBlock="SectionHeroButtons"
              className={`${hasBadge ? 'margin-top-8' : (!description && 'no-margin-top') || ''}`}
              data={actionButtons}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
